import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import EmployeeService from "../../../services/employee_service";

export const useAttendanceTeachers = ({ idTenant, isOpen }) => {
    const [isChangingTeacher, setIsChangingTeacher] = useState(false);
    const [substituteTeacher, setSubstituteTeacher] = useState(null);
    const [availableTeachers, setAvailableTeachers] = useState([]);
    const [isLoadingTeachers, setIsLoadingTeachers] = useState(false);

    useEffect(() => {
        if (isChangingTeacher && availableTeachers.length === 0) {
            const loadTeachers = async () => {
                setIsLoadingTeachers(true);
                try {
                    const employees = await EmployeeService.getEmployees(idTenant);
                    // Filtrando apenas ativos e preferencialmente professores
                    setAvailableTeachers(employees.filter(e => e.status === "active"));
                } catch (error) {
                    console.error("Erro ao puxar funcionários:", error);
                    toast.error("Erro ao carregar lista de professores.");
                } finally {
                    setIsLoadingTeachers(false);
                }
            };
            loadTeachers();
        }
    }, [isChangingTeacher, availableTeachers.length, idTenant]);

    // Reseta states quando fechar
    useEffect(() => {
        if (!isOpen) {
            setIsChangingTeacher(false);
            setSubstituteTeacher(null);
        }
    }, [isOpen]);

    return {
        isChangingTeacher,
        setIsChangingTeacher,
        substituteTeacher,
        setSubstituteTeacher,
        availableTeachers,
        isLoadingTeachers
    };
};
